__turbopack_context__.v({
  "plaa": "HighlightsBar-module-scss-module__ae7hIa__plaa",
  "root": "HighlightsBar-module-scss-module__ae7hIa__root",
  "secondary": "HighlightsBar-module-scss-module__ae7hIa__secondary",
  "wrapper": "HighlightsBar-module-scss-module__ae7hIa__wrapper",
});
